import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { CrazyCallConfigService } from '../services/crazycall-config.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class CrazyCallAppIdResolver implements Resolve<any> {
  constructor(private crazyCallConfigService: CrazyCallConfigService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<string> | Promise<string> | string {
    return this.crazyCallConfigService.appId;
  }
}
